export const Base = require("./Base.vue").default;
